{
  "__comment.error.app": "Erreurs générées dans l'app - weblate: copier-coller sans traduire cette ligne",
  "__comment.error.backend": "Erreurs générées depuis le backend - weblate: copier-coller sans traduire cette ligne",
  "admin.unauthorized": "Vous n'êtes pas autorisé à effectuer cette action",
  "anonymous.request": "Une erreur s'est produite. Si le problème persiste, merci de nous contacter",
  "app-service.not-connected": "Vous ne semblez pas être connecté à Internet.",
  "app-service.unavailable.description": "Un problème de connexion empêche l'accès au service. Veuillez vérifier votre connexion réseau.",
  "app.accessibility.community": "Page communauté",
  "app.accessibility.intentions": "Page des intentions",
  "app.accessibility.intentions-theme": "Page des intentions thématiques",
  "app.accessibility.messages": "Page des messages",
  "app.accessibility.unsubscribe-donation-mail": "Page de désinscription des mails de dons",
  "app.audio.listen": "Écouter l'audio",
  "app.audio.loading-error": "Une erreur est survenue pendant le chargement du fichier audio",
  "app.avoidance-navigation.content": "Contenu de la page",
  "app.banner.goal.goal": "Objectif : {amount} dons réguliers",
  "app.description": "Grâce à l''<strong>application Hozana</strong>, accédez en un clic à votre coin prière, découvrez de nouvelles communautés, déposez vos intentions où que vous soyez !",
  "app.discover": "Découvrir nos propositions",
  "app.donation.later.i-want": "Recevoir un rappel",
  "app.donation.later.success.toast": "Vous recevrez un rappel dans quelques jours",
  "app.download": "Télécharger l'application",
  "app.error": "Oops, une erreur est survenue, veuillez réessayer plus tard.",
  "app.how-to.open-menu": "Menu: pour ouvrir le menu lateral en appuyer sur Entrer, pour fermer le menu appuyer sur Esc",
  "app.i-donate": "Je donne",
  "app.maintenance": "<strong>Hozana</strong> est en cours de maintenance.\nPatientez quelques minutes avant de rafraîchir votre navigateur pour continuer.",
  "app.navigation.events-link": "Les rendez-vous Hozana !",
  "app.navigation.footer.faq.link": "Questions… et réponses !",
  "app.navigation.footer.guide.all": "Tous les articles de nos guides",
  "app.navigation.footer.guide.bible": "Découvrez la Bible",
  "app.navigation.footer.guide.catechism": "Catéchisme : des réponses à vos questions !",
  "app.navigation.footer.guide.feast-days": "Les fêtes chrétiennes",
  "app.navigation.footer.guide.meditation": "Guide de la méditation chrétienne",
  "app.navigation.footer.guide.miracles": "Découvrez les miracles et apparitions",
  "app.navigation.footer.guide.prayer": "Conseils pour prier",
  "app.navigation.footer.guide.rosary": "Guide pour prier le chapelet",
  "app.navigation.footer.guide.saints": "Découvrez les saints",
  "app.navigation.footer.who.we.are.link": "Qui sommes-nous ?",
  "app.navigation.jobs-link": "Offres d'emploi !",
  "app.navigation.main": "Menu principal",
  "app.navigation.open-menu": "Menu ouvert",
  "app.navigation.secondary": "Menu secondaire",
  "app.report-abuse.comment": "Signaler ce commentaire",
  "app.report-abuse.comment.success": "Ce commentaire a été signalé, merci pour votre aide !",
  "app.report-abuse.intention": "Signaler cette intention",
  "app.report-abuse.intention.success": "L'intention a été signalée, merci pour votre aide !",
  "app.report-abuse.placeholder": "Je signale ce contenu car…",
  "app.report-abuse.reason": "Merci de nous expliquer ci-dessous les raisons pour lesquelles vous souhaitez signaler ce contenu.",
  "app.report-abuse.report": "Signaler un abus",
  "app.report-abuse.send": "Signaler",
  "app.report-abuse.uplift": "Signaler ce message de soutien",
  "app.report-abuse.uplift.success": "Ce message a été signalée, merci pour votre aide !",
  "app.report-issue.button": "Je signale un problème",
  "app.report-issue.thank-you": "Merci ! Votre problème a bien été signalé",
  "auth.complete.choose-password": "Choisissez un mot de passe<br/>pour finaliser votre inscription à Hozana",
  "auth.complete.not-my-email": "Ce n'est pas mon adresse mail",
  "auth.login.email": "Se connecter par email",
  "auth.login.login": "Se connecter",
  "auth.login.welcome": "Bienvenue",
  "auth.otp.code.accessibility-label": "Code d'authentification à six chiffres",
  "auth.otp.code.description": "Nous avons envoyé un code temporaire à : {email}",
  "auth.otp.code.resend": "Renvoyer le code",
  "auth.otp.code.title": "Vérifiez vos emails",
  "auth.otp.login.title": "Quelle est votre adresse email ?",
  "auth.otp.signup.title": "Comment vous appelez-vous ?",
  "auth.privacy.notice": "Hozana est gratuit. Voici les <link>conditions générales</link>. Hozana ne transmettra jamais votre adresse email à un tiers sans votre accord.",
  "auth.signup.signup": "Créer un compte",
  "auth.social.apple": "Se connecter avec Apple",
  "auth.social.apple.missing-identity-token": "La connexion avec Apple n'a pas renvoyé de jeton d'identité",
  "auth.social.google": "Continuer avec Google",
  "auth.social.google.canceled": "La connexion avec Google a été annulée",
  "auth.social.google.missing-authorization-code": "La connexion avec Google n'a pas renvoyé de code d'autorisation",
  "birthdate.invalid": "La date de naissance est invalide",
  "captcha.invalid": "Le test de détecteur de robot a échoué, veuillez réessayer",
  "captcha.missing": "Veillez cocher \"Je ne suis pas un robot\"",
  "captcha.required": "Veuillez remplir le captcha",
  "comment.community.unknown": "La communauté est introuvable",
  "comment.delete.delete": "Supprimer le commentaire",
  "comment.delete.fail.none": "Le commentaire n'a pas pu être supprimé",
  "comment.delete.not.found": "Impossible de trouver le commentaire à supprimer",
  "comment.form.empty": "Rédigez un commentaire pour publier",
  "comment.from": "Commentaire de {contactName}",
  "comment.id.not-found": "Oups, nous n'avons pas pu afficher les réponses de ce commentaire",
  "comment.not-found": "Le commentaire n'a pas été trouvé",
  "comment.relative.time": "{prefix} {time}",
  "comment.relative.time.today": "Aujourd'hui à {time}",
  "comment.relative.time.week-day": "{weekday} à {time}",
  "comment.relative.time.yesterday": "Hier à {time}",
  "comment.relative.week-day": "{weekday}",
  "comment.update.not.found": "Le commentaire à mettre à jour est introuvable",
  "comment.write.your-comment": "Votre commentaire",
  "common.error.api.default": "Problème de connexion au serveur",
  "common.error.unknown": "Une erreur est survenue",
  "common.form.error.captcha.invalid": "Le captcha n'est pas valide. Veuillez réessayer.",
  "common.form.error.captcha.required": "Veuillez cocher \"Je ne suis pas un robot\"",
  "common.form.error.email.invalid": "Adresse email invalide",
  "common.form.error.fail": "Erreur inconnue, veuillez réessayer",
  "common.form.error.field.invalid": "Champ invalide, veuillez corriger",
  "common.form.error.field.required": "Veuillez renseigner ce champ",
  "common.form.error.message.required": "Message requis",
  "common.form.error.password-is-name": "Votre mot de passe doit être différent de votre nom",
  "common.form.error.password.different": "Veuillez confirmer avec le même mot de passe",
  "common.form.error.subject.required": "Sujet requis",
  "common.word.start-today": "Commence aujourd'hui",
  "common.word.start-tomorrow": "Commence demain",
  "common.word.tomorrow": "Demain",
  "communities.categories": "Catégories",
  "communities.categories.all": "Toutes les catégories",
  "communities.for-you.edit": "Modifier mes préférences",
  "communities.for-you.empty": "Répondez à quelques questions afin que nous puissions vous proposer des neuvaines, retraites ou communautés permanentes selon vos choix.",
  "communities.for-you.settings": "Je définis mes préférences",
  "communities.other-suggestions": "Autres propositions du moment",
  "communities.search": "Votre recherche",
  "communities.see-more": "Voir plus de communautés",
  "community.activity.inactive": "Inactive",
  "community.all": "Toutes les communautés",
  "community.already-exists": "Une communauté avec le même nom existe déjà",
  "community.close-for-today": "Fermer pour aujourd'hui",
  "community.communities.none-finished": "Vous n'avez terminé aucune neuvaine, retraite ou communauté encore",
  "community.communities.none-joined": "Vous n'avez rejoint aucune neuvaine, retraite ou communauté encore",
  "community.communities.suggested": "Suggéré pour vous",
  "community.communities.team-favorite": "❤️ Coup de coeur de l'équipe",
  "community.communities.view-all": "Voir toutes les communautés",
  "community.creation.suggestion": "Vous pouvez créer et proposer à tous du contenu de prière : neuvaine, parcours ou contenu quotidien...",
  "community.date.from-to": "du {fromDate} au {toDate}",
  "community.description.prayer.success": "Merci pour votre prière !",
  "community.description.read-more": "Lire la suite",
  "community.everlasting.unavailable-program": "Cette communauté n’a encore publié aucune prière.",
  "community.join-mails.activation": "Activer les mails",
  "community.join-mails.subtitle": "Cela vous servira également de rappel 😉",
  "community.join-mails.title": "Voulez-vous prier cette {lifetime, select, retreat {retraite} novena {neuvaine} other {communauté}} depuis votre boîte mail ?",
  "community.join-next.everlasting.start": "Une prière a été publiée aujourd’hui dans la communauté. Voulez-vous la prier ?",
  "community.join-next.no-publication.start": "En attendant {lifetime, select, novena {le début de la neuvaine} retreat {le début de la retraite} other {de recevoir une première prière}}, vous pouvez…",
  "community.join-next.pray-now": "Prier maintenant",
  "community.join-next.start": "Voulez-vous commencer la {lifetime, select, novena {neuvaine} other {retraite}} dès maintenant ?",
  "community.join-next.start-later": "Commencer plus tard",
  "community.join.already-joined": "Vous êtes déjà inscris à cette date à ce parcours",
  "community.join.card.button": "Rejoindre {lifetime, select, retreat {la retraite} novena {la neuvaine} other {cette communauté }} en cours",
  "community.join.confirmation.in-progress": "Vous avez rejoint la {lifetime, select, novena {neuvaine} other {retraite}} <strong>en cours</strong>.",
  "community.join.confirmation.soon": "Vous commencerez {lifetime, select, retreat {la retraite} novena {la neuvaine} other {la communauté}} le {date}{rescheduled, select, true {.} other {, <strong>dans {nbDays} {nbDays, plural, one {jour} other {jours}}</strong>.}}",
  "community.join.confirmation.today": "Vous commencez {lifetime, select, retreat {la retraite} novena {la neuvaine} other {la communauté}} <strong>aujourd'hui.</strong>",
  "community.join.congrats": "Bravo {userName} ! Vous êtes inscrit à la communauté",
  "community.join.congrats.comingSoon": "Bravo {userName} ! Vous commencerez la {lifetime, select, novena {neuvaine} other {retraite}} le {date}",
  "community.join.congrats.ongoing": "Bravo {userName} ! Vous rejoignez la {lifetime, select, novena {neuvaine} other {retraite}} à partir d’aujourd’hui",
  "community.join.congrats.startToday": "Bravo {userName} ! Vous commencez la {lifetime, select, novena {neuvaine} other {retraite}} aujourd’hui",
  "community.join.date": "Démarrez la {lifetime, select, retreat {retraite} novena {neuvaine} other {communauté}} à la date qui vous convient",
  "community.join.date.validate": "Je valide cette date",
  "community.join.error.no-subscription": "Oops ! Il semble y avoir une incohérence dans la date de souscription.",
  "community.join.from-date": "(à partir du jour {diffDays})",
  "community.join.infos": "Rejoignez les {nbMembers} utilisateurs qui prient {lifetime, select, retreat {la retraite} novena {la neuvaine} other {cette communauté }} en ce moment",
  "community.join.invalid-schedule-date": "La date choisie n'est pas valable",
  "community.join.not-schedulable": "Vous ne pouvez pas choisir de date pour cette communauté",
  "community.join.options.title": "Quand voulez-vous commencer cette {lifetime, select, retreat {retraite} novena {neuvaine} other {communauté}} ?",
  "community.join.scheduled-end-date.novena": "La neuvaine prendra fin le {date}",
  "community.join.scheduled-end-date.retreat": "La retraite prendra fin le {date}",
  "community.join.success.message": "Vous avez rejoint la {lifetime, select, retreat {retraite} novena {neuvaine} other {communauté}}.",
  "community.leave-community": "Quitter la communauté",
  "community.leave-everlasting-community": "Ne plus recevoir les prières",
  "community.leave.already.left": "Vous avez déjà quitté cette communauté",
  "community.leave.confirm": "Voulez-vous vraiment {lifetime, select, novena {arrêter cette neuvaine ?} retreat {arrêter cette retraite ?} other {quitter cette communauté ?}}",
  "community.leave.fail": "Une erreur est survenue, veuillez réessayer",
  "community.leave.success": "Vous avez quitté la {lifetime, select, novena {neuvaine} retreat {retraite} other {communauté}}",
  "community.load.error": "Une erreur est survenue lors du chargement de la communauté",
  "community.not-found": "Cette communauté n'existe pas",
  "community.not-joined": "Vous n'êtes pas ou plus membre de cette communauté.",
  "community.notifications.activate-push": "Activer les notifications",
  "community.notifications.receive-publications-push": "Voulez-vous recevoir un rappel {lifetime, select, novena {chaque jour de cette neuvaine} retreat {chaque jour de cette retraite} other {pour penser à prier}} ?",
  "community.notifications.receive-publications-push.subtitle": "Nous vous enverrons une notification {lifetime, select, novena {chaque jour de cette neuvaine} retreat {chaque jour de cette retraite} other {à chaque prière de cette communauté}}",
  "community.private.private": "Privée",
  "community.publication.error.publication.not-accessible": "Cette publication n'est pas accessible pour le moment.",
  "community.role.administrator.long": "Vous êtes administrateur",
  "community.role.animator.long": "Vous êtes animateur",
  "community.role.creator.long": "Vous êtes le créateur",
  "community.share.text": "Peut-être que quelqu’un de votre entourage pourrait être intéressé ? Demandez à l’Esprit Saint de vous éclairer 😇",
  "community.status.check.validating": "En cours de validation",
  "community.status.draft.word": "Brouillon",
  "community.tab.description": "Description",
  "community.toolbar.community": "Voir la {lifetime, select, retreat {retraite} novena {neuvaine} other {communauté}}",
  "community.toolbar.stop": "Arrêter la {lifetime, select, retreat {retraite} novena {neuvaine} other {communauté}}",
  "community.toolbar.title": "Espace animateur",
  "community.unavailable-program": "Le programme de cette {lifetime, select, retreat {retraite} other {neuvaine}} n’est pas encore disponible.",
  "community.unmodifiable": "Vous ne pouvez pas modifier cette communauté",
  "community.virtus.publications.empty": "Vos contenus s’afficheront ici",
  "communityAnnouncement.community.user.not-allowed": "Vous n'êtes pas autorisé à envoyer une annonce aux membres de cette communauté",
  "communityAnnouncement.message.too-long": "Oh ! Le contenu de votre annonce est trop long",
  "communityAnnouncement.subject.too-long": "Oh ! Le sujet de votre annonce est trop long",
  "contact.captcha_v2.title": "Veuillez valider que vous êtes un humain",
  "contact.email.invalid": "Veuillez entrer une adresse email valide",
  "contact.firstname.invalid": "Veuillez entrer votre prénom",
  "contact.firstname.placeholder": "Prénom",
  "contact.firstname.tooLong": "Le prénom ne peut pas dépasser 30 caractères",
  "contact.lastname.invalid": "Veuillez entrer votre nom",
  "contact.lastname.label": "Votre nom",
  "contact.lastname.placeholder": "Nom",
  "contact.load.error": "Une erreur est survenue lors de la recherche de votre correspondant.",
  "contact.message.alert": "Si vous signalez un problème rencontré sur le site ou l'application, merci de le détailler le plus précisément possible dans le champs ci-dessous :",
  "contact.message.invalid": "Veuillez entrer un message",
  "contact.message.label": "Contenu de votre message",
  "contact.message.tooShort": "Le message doit contenir au moins 100 caractères",
  "contact.send-message": "Envoyer un message",
  "contact.subject.invalid": "Veuillez entrer le sujet de votre message",
  "contact.subject.label": "Sujet de votre message",
  "contact.subject.placeholder": "Sujet",
  "contact.subtitle": "Nous nous ferons une joie de vous répondre 😊",
  "contact.success.toast": "Votre message a bien été envoyé. Vous vous répondrons au plus vite !",
  "content.forbidden-content": "Ce contenu n'est pas valide",
  "content.invalid": "Le contenu n'est pas valide ou est vide",
  "content.invalid-contain-email": "Votre intention ne doit pas contenir d'email",
  "content.invalid-contain-url": "Votre intention ne doit pas contenir de lien",
  "content.required": "Le contenu est manquant",
  "content.too-long": "Ce contenu est trop long. Merci de n'utiliser que des lettres ou chiffres",
  "content.too-short": "Ce contenu est trop court. Merci de n'utiliser que des lettres ou chiffres",
  "conversation.ambiguous-definition": "Oups, un petit problème est survenu. Si le problème persiste, merci de nous contacter",
  "conversation.block": "Bloquer la conversation",
  "conversation.few-seconds": "À l'instant",
  "conversation.mark-as-unread": "Marquer comme non lu",
  "conversation.not-found": "Cette conversation n'existe pas",
  "conversation.unblock": "Débloquer la conversation",
  "conversation.user.not-allowed": "Oh ! Vous n'avez pas accès à cette conversation. Êtes-vous sûr d'être connecté avec le bon compte ?",
  "conversation.you-blocked": "Vous avez bloqué la conversation",
  "conversations.unread": "Non lues",
  "cta.share": "Partagez",
  "dates.invalid": "Les dates ne sont pas valides",
  "day.count": "Jour {number}",
  "description.forbidden-content": "La description n'est pas valide",
  "description.invalid": "La description est manquante",
  "description.required": "La description est manquante",
  "description.too-long": "La description est trop longue",
  "description.too-short": "La description est trop courte",
  "device.delete.not.found": "L'appareil que vous souhaitez retirer n'a pas été trouvé",
  "discover.see-more": "Voir plus de contenu",
  "draft.conflict": "Cette publication ne peut être enregistrée en brouillon.",
  "email.already-exists": "L'email existe déjà",
  "email.invalid": "L'adresse email n'est pas valide",
  "email.user.not-found": "Aucun utilisateur trouvé avec cette adresse e-mail",
  "error.403.title": "Vous n'avez pas accès à cette page",
  "error.404.message": "Trouvez les communautés qui peuvent vous aider à prier",
  "error.404.quote": "Cherchez le seigneur tant qu'il se laisse trouver;\ninvoquez-le tant qu'il est proche.\n Isaïe 55,6",
  "error.404.title": "Désolé, cette page n'existe pas sur Hozana…",
  "favorite.not-found": "La publication favorite n'a pas été trouvée",
  "file.not-an-image": "Le fichier uploadé n'est pas une image. Seuls les fichiers JPG/PNG/GIF sont acceptés",
  "fraternity.download-app.benefit.content": "Accédez facilement au contenu de Virtus",
  "fraternity.download-app.benefit.fraternity": "Gardez contact avec votre fraternité",
  "fraternity.download-app.benefit.notifications": "Recevez la bonne information au bon moment",
  "fraternity.download-app.cta": "Télécharger l'App",
  "fraternity.download-app.description": "Téléchargez l'application Hozana pour retrouver facilement Virtus tous les jours.",
  "fraternity.download-app.dismiss": "Non, merci",
  "fraternity.download-app.free": "Hozana est une application <strong>associative</strong> et entièrement <strong>gratuite</strong>.",
  "fraternity.download-app.title": "Virtus à portée de main",
  "fraternity.gender.question": "Vous êtes :",
  "fraternity.gender.title": "Pour vous proposer des fraternités non mixtes",
  "fraternity.join.already-have": "J'ai déjà une fraternité",
  "fraternity.join.already-have-description": "Vous savez déjà avec qui vous allez vivre Virtus",
  "fraternity.join.find": "Trouvez-moi une fraternité",
  "fraternity.join.find-description": "Nous vous mettrons en relation avec d'autres priants",
  "fraternity.join.subtitle": "Les fraternités Virtus sont non mixtes.",
  "fraternity.join.title": "Avez-vous des proches avec qui constituer une fraternité ?",
  "fraternity.lead.accept": "Je veux bien",
  "fraternity.lead.decline": "Je ne préfère pas",
  "fraternity.lead.description": "Ce rôle consiste simplement à organiser et animer les réunions de fraternité. Vous n'aurez pas à tout porter ni à être un expert spirituel.",
  "fraternity.lead.learn-more": "En savoir plus sur ce rôle",
  "fraternity.lead.title": "Voulez-vous être chef de fraternité ?",
  "fraternity.onboarding.close.body": "En quittant maintenant vous serez inscrit à Virtus sans être rattaché à une fraternité.",
  "fraternity.onboarding.close.footer": "Vous pourrez demander à être rattaché à une fraternité à tout moment.",
  "fraternity.onboarding.close.title": "Voulez-vous vraiment vivre Virtus sans fraternité ?",
  "fraternity.place.city-label": "Dans quelle ville habitez-vous ?",
  "fraternity.place.hint": "Choisissez des rencontres près de chez vous ou entièrement à distance.",
  "fraternity.place.nearby": "Près de chez vous",
  "fraternity.place.nearby-description": "Rechercher des participants dans votre secteur",
  "fraternity.place.remote": "À distance",
  "fraternity.place.remote-description": "Retrouvez votre fraternité où que vous soyez",
  "fraternity.place.title": "Où souhaitez-vous rencontrer votre fraternité ?",
  "fraternity.presentation.item.encourage": "Encouragez-vous tout au long du parcours",
  "fraternity.presentation.item.pray": "Priez les uns pour les autres",
  "fraternity.presentation.item.share": "Partagez chaque semaine ce que vous vivez",
  "fraternity.presentation.subtitle": "Virtus se vit au sein d'une fraternité non mixte de 8 personnes.",
  "fraternity.presentation.title": "Vivez votre carême en fraternité",
  "fraternity.ready.eager-no": "J'hésite encore un peu 😅",
  "fraternity.ready.eager-yes": "Oui, je suis prêt(e) à vivre ce Carême pleinement ! 💪🏻",
  "fraternity.ready.subtitle": "Le parcours Virtus est exigeant. Êtes-vous prêt(e) à vous engager sérieusement dans ce carême ?",
  "fraternity.ready.title": "Bienvenue sur le parcours Virtus !",
  "fraternity.recap.cta": "Chercher une fraternité",
  "fraternity.recap.lead": "Chef de fraternité",
  "fraternity.recap.place": "Lieu de fraternité souhaité",
  "fraternity.recap.sex": "Sexe",
  "fraternity.recap.subtitle": "Corrigez-les si nécessaire avant de lancer la recherche.",
  "fraternity.recap.title": "Vérifiez vos informations",
  "fraternity.step-label": "Votre fraternité · {step} / 4",
  "fromDate.in-the-futur": "Mince ! Vous devez choisir une date future comme date de début",
  "fromDate.in-the-past": "Mince ! Vous ne pouvez pas choisir une date passée comme date de début",
  "getCommunitiesJoined.user.not-found": "Nous ne trouvons pas les communautés",
  "getCommunitiesWithRole.user.not-found": "Nous ne trouvons pas les communautés",
  "getCommunityNotifications.subscriptionId.not-found": "Nous n'avons pas pu charger vos préférences de notifications pour cette communauté",
  "guestName.required": "Prénom manquant",
  "guestName.too-long": "Le prénom est trop long",
  "guide.not-found": "Les articles de ce guide n'ont pas été trouvés",
  "hash.invalid": "Une erreur est survenue: 'hash invalid'",
  "hash.required": "Une erreur est survenue: 'hash required'",
  "home.faq.title.head": "Comment ça marche ?",
  "home.tagline": "Notre prière sauvera le monde",
  "home.tagline.sub": "Et elle changera votre vie !",
  "home.welcome.app-section.title": "Téléchargez l'application Hozana",
  "home.welcome.intentions.title": "Déposez vos intentions,\npriez pour les autres",
  "iframe.error.description": "Le contenu n'a pas pu être chargé. Vérifiez votre connexion internet et réessayez.",
  "iframe.error.title": "Connexion impossible",
  "intention.anonymous-praying": "Anonyme",
  "intention.answer.uplift": "Répondez à ce message de soutien",
  "intention.arrival.just-joined": "{userName} vient de rejoindre Hozana",
  "intention.arrival.welcome-pray": "Souhaitez-lui la bienvenue en prière !",
  "intention.birthday.celebration": "{username} fête ses {years} ans !",
  "intention.birthday.pray": "Souhaitez-lui bon anniversaire en prière !",
  "intention.birthday.years-old": "{age, plural, one {{age} an} other {{age} ans}}",
  "intention.created.description": "Elle sera proposée aux membres de la communauté pendant 48 heures.",
  "intention.created.success": "Votre intention est déposée",
  "intention.delete.confirm-message1": "Voulez-vous vraiment supprimer votre intention en cours d'affichage ?",
  "intention.delete.confirm-message2": "Les priants ne pourrons plus prier pour votre intention, et vous ne pourrez pas remercier ceux qui ont déjà prié pour votre intention.",
  "intention.delete.delete": "Supprimer mon intention",
  "intention.finished.arrival": "{count, plural, =0 {Personne n'a} one {{count} personne a} other {{count} personnes ont}} prié pour vous souhaiter la bienvenue sur Hozana !",
  "intention.finished.birthday": "{birthdayDate}, {count, plural, =0 {personne n'a} one {{count} personne a} other {{count} personnes ont}} prié pour vous souhaiter un bon anniversaire !",
  "intention.finished.intention": "Le temps d'affichage de votre intention est écoulé. {count, plural, =0 {Personne n'a} one {{count} personne a} other {{count} personnes ont}} prié pour vous. <link>Voir l’intention</link>",
  "intention.finished.prayers": "{count, plural, =0 {Personne n'a} one {{count} personne a} other {{count} personnes ont}} prié {type, select, arrival {pour vous souhaiter la bienvenue sur Hozana} birthday {pour vous à l’occasion de votre anniversaire} other {pour votre intention} }{count, plural, =0 {.} one {, souhaitez-vous la remercier ?} other {, souhaitez-vous les remercier ?}}",
  "intention.finished.thank": "Je remercie les priants",
  "intention.from": "Intention de {contactName}",
  "intention.invitation-to-pray-for": "{name} confie cette intention à votre prière",
  "intention.load.error": "Une erreur est survenue. L'intention n'a pas pu être chargée.",
  "intention.not-found": "L'intention n'a pas été trouvée",
  "intention.page.button": "Déposer une intention",
  "intention.pray-for": "Prier pour des intentions",
  "intention.prayed.already": "Vous avez prié pour cette intention.",
  "intention.prayed.already-with": "Vous{count, plural, =0 {} one { et une autre personne} other { et # autres personnes} } avez prié pour cette intention. Merci !",
  "intention.prayed.birthday": "Vous{count, plural, =0 {} one { et une autre personne} other { et # personnes}} avez prié pour {userName}",
  "intention.prayed.by": "{count, plural, =0 {Personne n'a encore prié} =1 {{name} a déjà prié} =2 {{otherNames} et {name} ont déjà prié} =3 {{otherNames} et {name} ont déjà prié} =4 {{otherNames}, {name} et une autre personne ont déjà prié} other {{otherNames}, {name} et {remainingCount} autres personnes ont déjà prié}} pour cette intention",
  "intention.prayed.pray-for-others": "👉🏻 Voulez-vous prier pour d’autres intentions ?",
  "intention.prayed.thanks": "Merci !",
  "intention.prayed.with": "🙏 {count} {count, plural, one {personne a prié} other {personnes ont prié}} avec vous pour cette intention",
  "intention.prayer.not-found": "Cet utilisateur ne semble pas avoir prié pour vous",
  "intention.prayer.watchman.activate-notifications": "Pour pouvoir recevoir la notification, vous avez besoin de l'activer.",
  "intention.prayer.watchman.became-watchman": "Vous êtes Veilleur de prière !",
  "intention.prayer.watchman.become": "Devenez Veilleur de Prière",
  "intention.prayer.watchman.commitment": "Vous vous êtes engagé à recevoir et prier chaque jour 3 intentions",
  "intention.prayer.watchman.engagement.1": "En devenant <strong>Veilleur de prière</strong> :",
  "intention.prayer.watchman.engagement.2": "3 intentions par jour",
  "intention.prayer.watchman.engagement.3": "seront confiées à vos prières",
  "intention.prayer.watchman.fetching": "Nous récupérons les 3 intentions qui vous sont confiées aujourd'hui",
  "intention.prayer.watchman.join": "Devenir veilleur de prière",
  "intention.prayer.watchman.many-watchmen": "🙏 Déjà <strong>103 456</strong> personnes engagées !",
  "intention.prayer.watchman.method-reminder": "Comment voulez-vous recevoir votre rappel de prière quotidien ?",
  "intention.prayer.watchman.pray-support": "Soutenez vos frères et sœurs par vos prières",
  "intention.prayer.watchman.reminder.by-email": "Par un email",
  "intention.prayer.watchman.reminder.by-notification": "Par une notification",
  "intention.prayer.watchman.resign": "Je souhaite arrêter",
  "intention.prayer.watchman.stop": "Arrêter mon engagement",
  "intention.prayers.list.title": "Ils ont prié pour vous",
  "intention.publish.button": "Je dépose mon intention",
  "intention.reload": "Voir d'autres intentions",
  "intention.share": "Partagez cette intention",
  "intention.time-left": "{count}h",
  "intention.title": "Déposez vos intentions, Priez pour celle des autres",
  "intention.watchman.arrival.just-joined": "Vous priez pour {userName} qui vient d’arriver sur Hozana",
  "intention.write.here": "Ecrivez votre intention de prière ici",
  "intentions.not-found": "Nous n'avons pas trouvé d'intention à afficher",
  "intentions.title": "Déposez une intention sur Hozana !",
  "intentions.view": "Voir les intentions",
  "introduction.forbidden-content": "Le texte d'introduction n'est pas valide",
  "introduction.too-long": "Le texte d'introduction est trop long",
  "introduction.too-short": "Le texte d'introduction est trop court",
  "joinCommunity.community.join.already-finished-community": "Cette communauté est terminée",
  "journey.discover.current": "Voir les parcours du moment",
  "journey.none.now": "Aucun parcours pour le moment",
  "journey.novenas-and-journeys": "Neuvaines et parcours",
  "journey.once.subscribed": "Une fois que vous serez inscrit à une neuvaine ou un parcours, vous le retrouverez ici",
  "journey.prayed.today": "Prié aujourd'hui",
  "journey.see-history": "Historique",
  "lang.unsupported": "La langue que vous demandez n'est pas supporté actuellement",
  "language.en": "Anglais",
  "language.es": "Espagnol",
  "language.fr": "Français",
  "language.it": "Italien",
  "language.pl": "Polonais",
  "language.pt": "Portugais",
  "leave.confirm.message": "Votre compte a bien été supprimé",
  "leave.guides-title": "Découvrez nos guides thématiques",
  "leave.pray-differently": "Vous aimeriez prier autrement ?",
  "leave.sign-up-again": "👋🏻 Nous serons ravis de vous accueillir à nouveau si vous souhaitez continuer à prier avec nous",
  "login.account.disabled": "Votre compte est désactivé",
  "login.account.missing": "Aucun compte n'est associé à cette adresse email",
  "login.code-input.check-email": "Veuillez vérifier le code reçu par mail",
  "login.code.required": "Code requis",
  "login.csrf.invalid": "Votre session a expiré, veuillez réessayer",
  "login.email.invalid": "Adresse email invalide",
  "login.email.not-provided": "Veuillez indiquer votre adresse email",
  "login.email.required": "Adresse email requise",
  "login.failed": "Le code est invalide ou expiré",
  "login.password.required": "Mot de passe requis",
  "meeting.organizer.place.name-placeholder": "Église Saint Pierre",
  "meeting.organizer.time-invalid": "Veuillez fournir une heure de rencontre sous format HH:MM",
  "meeting.organizer.timeStart-invalid": "L'heure de début doit être plus petite que celle de fin",
  "message.automatic-message": "Message automatique",
  "message.delete": "Supprimer le message",
  "message.delete.user.not_allowed": "Oh ! Vous ne pouvez pas supprimer ce message",
  "message.deleted": "Message supprimé",
  "message.from": "Message de {contactName}",
  "message.godfather.welcome-message.to-godfather": "{contactName} vient de rejoindre Hozana grâce à votre invitation. Souhaitez-lui la bienvenue !",
  "message.godfather.welcome-message.to-godson": "Vous avez rejoint Hozana grâce à l'invitation de {contactName}. Bienvenue !",
  "message.godfather.welcome-title.to-godfather": "Me voici",
  "message.godfather.welcome-title.to-godson": "Bienvenue sur Hozana !",
  "message.invalid": "Message invalide",
  "message.list.title": "Messagerie",
  "message.list.title.conversation": "Pour entamer une conversation avec un utilisateur d’Hozana, commencez par prier sur la page des Intentions.",
  "message.list.title.cta": "Je prie pour une intention",
  "message.list.title.intention": "La personne pour qui vous aurez prié pourra vous remercier et entamer une conversation avec vous.",
  "message.prayer-on-arrival.has-thanked-you": "{contactName} vous remercie d'avoir prié pour son arrivée sur Hozana.",
  "message.prayer-on-arrival.you-thanked-for": "Vous avez remercié {contactName} d'avoir prié pour votre arrivée sur Hozana.",
  "message.prayer-on-birthday.has-thanked-you": "{contactName} vous remercie d'avoir prié pour son anniversaire.",
  "message.prayer-on-birthday.you-thanked-for": "Vous avez remercié {contactName} d'avoir prié pour votre anniversaire.",
  "message.prayer-on-intention.thank-you": "Vous avez remercié {contactName} d'avoir prié pour votre intention",
  "message.prayer-on-intention.thanked-you": "{contactName} vous remercie d'avoir prié pour son intention",
  "message.prayer.has-just-prayed-for-you.short-multiple": "{count} personnes ont prié pour vous !",
  "message.prayer.has-just-prayed-for-you.short-single": "{contactName, select, _ {Quelqu'un} other {{contactName}}} vient de prier pour vous !",
  "message.prayer.has-prayed-for-you.long": "{contactName} a prié pour vous",
  "message.prayer.you-prayed-for.long": "Vous avez prié pour {contactName}",
  "message.reported": "Ce message a été signalé et la conversation bloquée, merci pour votre aide !",
  "message.suspicious.received": "Votre interlocuteur vous a envoyé un lien à cliquer, un numéro à appeler, ou vous a proposé un lieu de rendez-vous. Veuillez vous assurer d’être en confiance avec cette personne avant de poursuivre vos échanges.",
  "message.suspicious.sent": "Il semblerait que vous ayez partagé votre numéro de téléphone, votre email ou un lien. Veuillez vous assurer d'être en confiance avec la personne avant de poursuivre les échanges sur une autre plateforme, moins sécurisée.",
  "message.textarea.help.return": "Touches Shift + Entrée pour retourner à la ligne",
  "message.unselected": "Aucune conversation sélectionnée",
  "message.update.user.not_allowed": "Oh ! Vous ne pouvez pas modifier ce message",
  "missing.parameters": "Oups ! Il manque des paramètres pour envoyer un message de soutien.",
  "name.exists": "Il existe déjà une publication portant ce nom",
  "name.forbidden-content": "Ce nom n'est pas valide",
  "name.invalid": "Prénom invalide",
  "name.required": "Veuillez renseigner votre prénom",
  "name.too-long": "Ce nom est trop long. Merci de n'utiliser que des lettres ou chiffres",
  "name.too-short": "Ce nom est trop court. Merci de n'utiliser que des lettres ou chiffres",
  "native.push.how-to.reactivate.description": "En cliquant sur \"Oui j'active les notifications,\", nous allons vous guider vers les réglages de votre iPhone. Activez simplement l'option \"Notifications\", appuyez sur la flèche de retour ⬅️ en haut pour revenir !",
  "navigation.confession-link": "Se confesser",
  "navigation.guides.title": "Nos guides",
  "navigation.intentions": "Déposez une intention",
  "navigation.live-page-link": "Messes et prière en direct",
  "navigation.search": "Recherchez sur Hozana",
  "notificationEmail.invalid": "L'email des notifications est invalide.",
  "oldPassword.invalid": "Votre mot de passe actuel ne correspond pas à celui renseigné.",
  "page.gone": "Cette page n'existe plus",
  "page.not-found": "Aucune page correspondante trouvée",
  "password.required": "Mot de passe requis",
  "password.too-long": "Le mot de passe est trop long",
  "payload.bad-content": "Le contenu est invalide",
  "payload.text-too-long": "Hum ! Votre message est trop long",
  "pictureFileId.required": "L'image est manquante",
  "postIntention.content.too-long": "Le contenu de l'intention est trop long",
  "pray.amen": "Amen !",
  "pray.comment.title": "Vous priez pour {userName}",
  "pray.entrust-intention": "Confiez une intention {buttonText}",
  "pray.entrust-intention.body": "D’autres priants d’Hozana prieront pour votre intention.",
  "pray.i-pray.short": "Je prie",
  "pray.intention.arrival.title": "Vous priez pour {userName} qui vient d'arriver sur Hozana",
  "pray.intention.birthday.title": "C'est l'anniversaire de {userName} !",
  "pray.intention.community.show": "Prier pour l’intention de {user}, également {lifetime, select, retreat {inscrit(e) à cette retraite} novena {inscrit(e) à cette neuvaine} other {membre de cette communauté}}",
  "pray.intention.publication.done": "Intention déposée par {user}",
  "pray.intention.publication.show": "{user} prie aussi avec “{community}”, voulez-vous prier pour son intention ?",
  "pray.intention.show": "Et maintenant, voulez-vous prier pour l'intention de {user} ?",
  "pray.intention.title": "Vous priez pour l'intention de {userName}",
  "pray.pray": "Prier",
  "pray.pray-today": "Prier aujourd'hui",
  "pray.prayed": "J'ai prié",
  "pray.prayer-sent": "Votre intention de prière a bien été envoyée",
  "pray.uplift.description": "Seul(e) {userName} verra ce message",
  "pray.uplift.sent": "Votre message de soutien a bien été envoyé",
  "pray.uplift.title": "Voulez-vous déposer un message de soutien à {userName} ?",
  "pray.write-intention": "Voulez-vous aussi déposer une intention de prière ?",
  "pray.your-intention": "Votre intention de prière",
  "prayer-space.discover": "Ceci pourrait vous intéresser",
  "prayer-space.everlasting.load.error": "Une erreur est survenue lors du chargement de la section « Au quotidien »",
  "prayer-space.journey.load.error": "Une erreur est survenue lors du chargement de la section « Neuvaines et parcours »",
  "prayer-space.onboarding.step-1.description": "Toute l’équipe d’Hozana est heureuse de vous présenter ce nouveau Coin Prière, pour vous aider à mieux grandir dans la fidélité à votre prière quotidienne.",
  "prayer-space.onboarding.step-1.title": "Nouveau Coin Prière !",
  "prayer-space.onboarding.step-2.description": "Retrouvez facilement les neuvaines et parcours que vous suivez en ce moment, et visualisez votre progression !",
  "prayer-space.onboarding.step-2.title": "Suivez vos Neuvaines et Parcours",
  "prayer-space.onboarding.step-3.description": "Retrouvez dans la section « Au quotidien » vos prières quotidiennes : évangile du jour, liturgie des heures, prières avec le saint du jour, etc.",
  "prayer-space.onboarding.step-3.title": "Retrouvez vos prières quotidiennes",
  "prayer-space.onboarding.step-4.description": "Dans la section « Ceci pourrait vous intéresser », découvrez les propositions du moment et redécouvrez les neuvaines et parcours que vous avez aimé prier.",
  "prayer-space.onboarding.step-4.title": "Découvrez la richesse de la prière sur Hozana",
  "prayer-space.welcome.discover": "Toutes nos propositions",
  "prayer-space.welcome.end-paragraph": "Si ces propositions ne correspondent pas à ce que vous cherchez, découvrez l’ensemble de nos contenus, je suis sûr que vous trouverez une neuvaine, retraite ou communauté permanente qui vous conviendra.",
  "prayer-space.welcome.paragraph": "<strong>Bonjour {userName},</strong>\nBienvenue sur votre <strong>coin prière</strong> 🙏🏻 !\nC’est ici que vous retrouverez les prières qui vous seront proposées.\n👉🏻 Pour recevoir des prières, <strong>vous pouvez dès maintenant vous inscrire à un contenu de prière</strong>",
  "prayer.start": "Commencer à prier",
  "prayerContent.invalid": "Le corps de la prière n'est pas valide ou est vide",
  "prayerContent.too-long": "Le contenu de la prière de votre communauté est trop long",
  "prayerName.invalid": "Le titre de la prière n'est pas valide ou est vide",
  "prayerName.required": "Veuillez donner un nom à la prière de votre communauté",
  "prayerName.too-long": "Le nom de la prière de votre communauté est trop long",
  "prayerSample.not-found": "Oups ! Vous ne pouvez pas choisir cette prière",
  "publication.already-exists": "Une publication identique a été programmée à moins d'une heure d'intervalle",
  "publication.comment.loadmore": "Charger plus de commentaires",
  "publication.comment.loadmoreanswers": "Charger plus de réponses",
  "publication.comment.show": "Afficher les commentaires",
  "publication.comment.title": "{count} {count, plural, one {Commentaire} other {Commentaires}}",
  "publication.day": "Jour {day}",
  "publication.favorite.add": "Enregistrer en favoris",
  "publication.favorite.how-to": "Vous pouvez enregistrer une publication en cliquant sur le bouton des options de la publication",
  "publication.favorite.none.now": "Aucune publication favorite",
  "publication.favorite.remove": "Ne plus enregistrer",
  "publication.favorite.removed": "La publication a été retirée de vos favoris",
  "publication.favorite.success": "La publication a été ajoutée à vos favoris",
  "publication.frequency.type.daily": "Chaque jour",
  "publication.frequency.type.long.daily": "Une prière chaque jour",
  "publication.frequency.type.long.monthly": "Une prière {value, plural, one {une fois} other {# fois}} par mois",
  "publication.frequency.type.long.sporadically": "Une prière de temps en temps",
  "publication.frequency.type.long.weekly": "Une prière chaque {value}",
  "publication.frequency.type.monthly": "{value, plural, one {Une fois} other {# fois}} par mois",
  "publication.frequency.type.sporadically": "De temps en temps",
  "publication.frequency.type.weekly": "Chaque {value}",
  "publication.goto": "Voir la communauté",
  "publication.load.error": "Une erreur est survenue. La publication n'a pas pu être chargée.",
  "publication.not-found": "Cette publication n'a pas été trouvée",
  "publication.prayed": "🙏 {count} {count, plural, one {personne a prié} other {personnes ont prié}} avec vous",
  "publication.prayed-by": "{count, plural, =0 {Vous avez prié pour cette publication} =1 {Vous et une autre personne avez prié pour cette publication} other {Vous et {count} autres personnes avez prié pour cette publication}}",
  "publication.prayed-by.short": "{count, plural, =0 {Vous avez prié} =1 {Vous et une autre personne avez prié} other {Vous et {count} autres personnes avez prié}}",
  "publication.prayed.share.body": "Partagez-lui la publication ou la communauté 😇",
  "publication.prayed.share.button": "Je partage à un ami",
  "publication.prayed.share.choose.body": "En partageant du contenu de prière, vous allez peut-être<strong> transformer en profondeur la vie de quelqu’un ! 😇 </strong>",
  "publication.prayed.share.choose.title": "Que voulez-vous partager ?",
  "publication.prayed.share.community.button": "Je partage la communauté",
  "publication.prayed.share.community.modal.title": "Partagez cette communauté",
  "publication.prayed.share.publication.button": "Je partage la publication",
  "publication.prayed.share.publication.modal.title": "Partagez cette publication",
  "publication.prayed.share.title": "Connaissez vous quelqu'un qui pourrait être touché par la prière que vous venez de lire ?",
  "publication.update": "Modifier la publication",
  "publicationFrequencyType.required": "Veuillez indiquer la fréquence de publication",
  "publicationFrequencyValue.invalid": "La fréquence de publication choisie n'est pas valide",
  "publicationFrequencyValue.required": "Veuillez renseigner une fréquence de publication",
  "push.activated": "Les notifications ont bien été activées",
  "push.allow.message": "Veuillez maintenant accepter la demande de votre navigateur pour activer les notifications.",
  "push.blocked.how-to.reactivate": "Comment réactiver les notifications ?",
  "push.blocked.how-to.settings.allow": "autorisez alors <i>hozana.org</i> à envoyer des notifications.",
  "push.blocked.how-to.settings.find-hozana": "dans la liste des sites, trouvez <i>hozana.org</i>,",
  "push.blocked.how-to.settings.find-list": "trouvez soit les autorisations accordées aux sites, soit les paramètres des notifications,",
  "push.blocked.how-to.settings.icon": "Si vous ne voyez pas cette icône, il vous faudra aller dans les paramètres du navigateur :",
  "push.blocked.how-to.url-icon.allow": "vous n'aurez alors plus qu'à lever l'interdiction d'envoi des notifications.",
  "push.blocked.how-to.url-icon.browser": "Dans beaucoup de navigateurs, vous trouverez une icône en forme de cadenas dans la barre d'adresse du site : à gauche ou à droite de <i>hozana.org/communaute/…</i>",
  "push.blocked.how-to.url-icon.click": "cliquez sur cette icône, et trouvez l'option « notifications »,",
  "push.blocked.message": "Vous avez bloqué les notifications sur cet appareil. Veuillez les réactiver si vous voulez recevoir à nouveau des notifications de la part d'Hozana.",
  "push.blocked.support-link": "Visiter l'aide dédiée de {browser} pour plus de détails en cas de problème",
  "push.blocked.title": "Notifications bloquées",
  "reportAbuse.reason.required": "Vous devez spécifier la raison de votre signalement",
  "reportAbuse.type.invalid": "Oups ! Erreur technique : votre signalement n'a pas été envoyé",
  "resetPassword.token.invalid": "Une erreur est survenue : veuillez réessayer en cliquant à nouveau sur \"Mot de passe oublié ?\"",
  "role.invalid": "Ce rôle ne peut pas être accepté",
  "rosario.bloc.cta": "Je prie le chapelet sur Rosario",
  "rosario.bloc.description.1": "1 – Constituez un groupe de prière de 5 personnes",
  "rosario.bloc.description.2": "2 – Chaque jour, chacun reçoit un mystère du rosaire et prend 5 minutes dans sa journée pour le méditer en récitant une dizaine",
  "rosario.bloc.description.3": "3 – À la fin de la journée, le groupe aura médité les 5 mystères du jour complétant ainsi un chapelet entier : c’est le chapelet vivant !",
  "rosario.bloc.title": "Découvre la 1ère application de chapelet vivant !",
  "rosario.xmrpms.cta": "Participer au cadeau",
  "rosario.xmrpms.description": "En mai, mois de Marie, <strong>chaque dizaine</strong> priée sur Rosario est <strong>une rose</strong> qui lui est offerte !",
  "rosario.xmrpms.objective": "Objectif : <strong>5 millions de roses d’ici le 31 mai.</strong>",
  "rosario.xmrpms.title": "Rejoignez un GRAND cadeau à Marie",
  "scheduledTime.invalid": "La date de programmation de la publication n'est pas valide",
  "score-threshold-not-met": "Le score de vérification n'a pas été atteint. Veuillez compléter la vérification.",
  "sendMessage.payload.bad-content": "Hum ! Vous ne pouvez pas envoyer le contenu de ce message",
  "settings.account.birthdate": "Date de naissance",
  "settings.account.confirm-password": "Confirmez votre nouveau mot de passe",
  "settings.account.current-password": "Votre ancien mot de passe",
  "settings.account.delete": "Supprimer le compte",
  "settings.account.delete.confirm": "Vous vous apprêtez à supprimer votre compte Hozana. Attention, cette action est irréversible. \n\nPour confirmer la suppression définitive de votre compte, entrez le mot <strong>SUPPRIMER</strong> (en majuscule) dans le champ ci-dessous puis confirmez.",
  "settings.account.delete.error-input": "Vous devez écrire SUPPRIMER ici",
  "settings.account.delete.input": "Ecrivez SUPPRIMER ici",
  "settings.account.new-password": "Votre nouveau mot de passe",
  "settings.card.community.announce": "Recevez les annonces",
  "settings.card.community.announce.details": "Pour permettre aux porteurs de la communauté de vous envoyer un message",
  "settings.card.community.prayer": "Recevez chaque prière",
  "settings.card.notifs.email": "Par email",
  "settings.card.notifs.push": "Par notification",
  "settings.email.disable.all": "Activer les emails pour tous les paramètres",
  "settings.header.notifications": "Emails et notifications",
  "settings.header.title.community": "Paramètres de la communauté",
  "settings.input.email-is-not-valid": "Veuillez renseigner une adresse email valide",
  "settings.input.name-is-not-email": "Veuillez renseigner simplement un prénom",
  "settings.input.password.label": "Mot de passe de votre compte",
  "settings.input.password.social-connect": "Vous êtes connecté par un compte {socialName}. Pour vous connecter par mot de passe, définissez-en un.",
  "settings.input.title.placeholder": "Mr, Mme, Père, Soeur...",
  "settings.language.title": "Langue de votre compte",
  "settings.notifications.community-registration.title": "Vous vous inscrivez à une communauté, neuvaine ou retraite",
  "settings.notifications.disable.all": "Activer les notifications pour tous les paramètres",
  "settings.notifications.end-of-novena.title": "Votre parcours se termine",
  "settings.notifications.general.description": "Mails et notifications des intentions, et autres fonctionnalités",
  "settings.notifications.general.title": "Notifications générales",
  "settings.notifications.incriptions.description": "Mails et notifications des neuvaines, parcours et contenus quotidiens",
  "settings.notifications.incriptions.title": "Notifications liées à mes inscriptions",
  "settings.notifications.intention-end-time.title": "Fin d'affichage de votre intention de prière",
  "settings.notifications.invited-join.title": "Un invité rejoint Hozana grâce à vous",
  "settings.notifications.message.title": "Nouveau message",
  "settings.notifications.newsletter.title": "Newsletter Hozana",
  "settings.notifications.no-ongoing-community.title": "Rappel pour rejoindre un parcours",
  "settings.notifications.pray-remind.title": "Rappel de prière quotidien",
  "settings.notifications.watchman-remind.title": "Rappel Veilleur de prière",
  "settings.notifications.watchman.description": "Paramètres et rappels",
  "settings.notifications.watchman.title": "Vous êtes Veilleur de prière",
  "settings.profile-and-settings": "Profil et paramètres",
  "settings.unsubscribe-presubscriber.error": "Une erreur est survenue lors de la désinscription",
  "settings.unsubscribe-presubscriber.success": "Vous avez bien été désinscrits",
  "share.community": "Partagez cette {lifetime, select, retreat {retraite} novena {neuvaine} other {communauté}}",
  "share.community.share": "Partager cette {lifetime, select, retreat {retraite} novena {neuvaine} other {communauté}}",
  "share.copied-link": "Lien copié",
  "share.copy-link": "Copier le lien",
  "share.intention.email-body": "Je t'invite à prier pour cette intention : {intentionUrl}.",
  "share.intention.share": "Partager cette intention",
  "share.my.intention.email-body": "Je t'invite à prier pour mon intention : {intentionUrl}.",
  "share.publication.email-body": "Je t'invite à découvrir cette publication « {publicationName} » sur Hozana : {publicationUrl}.",
  "share.share": "Partager",
  "share.share-by-email": "Partager par email",
  "share.share-by-email-body": "Je t'invite à découvrir cette {lifetime, select, retreat {retraite} novena {neuvaine} other {communauté}} sur Hozana « {communityName} » : {url}.",
  "share.wording.send-email": "Envoyer un email",
  "share.wording.share-on-whatsapp": "Partagez sur Whatsapp",
  "signup.captcha.required": "Veuillez cocher \"Je ne suis pas un robot\"",
  "signup.code.invalid": "Le code est invalide ou expiré",
  "signup.email.exists": "Un compte existe déjà avec cette adresse email",
  "signup.email.invalid": "Adresse email invalide",
  "signup.email.required": "Adresse email requise",
  "signup.fail": "Une erreur est survenue lors de la création de votre compte",
  "signup.name.invalid": "Une erreur est survenue à cause de votre prénom",
  "signup.name.required": "Prénom requis",
  "signup.password.required": "Mot de passe requis",
  "startConversation.payload.bad-content": "Hum ! Vous ne pouvez pas envoyer le contenu de ce message",
  "startConversation.user.not-found": "Hum ! Votre message ne doit pas dépasser 10 000 caractères",
  "tab.discover": "Découvrir",
  "tab.error.generic-description": "Cet onglet a rencontré une erreur.",
  "tab.error.try-again": "Réessayer",
  "tab.messaging": "Messages",
  "tab.prayer-space": "Coin prière",
  "tag.not-found": "Le tag n'existe pas",
  "thanks.prayed.watchman.intentions": "Merci pour votre fidélité",
  "timeout-or-duplicate": "Le captcha a expiré ou a déjà été utilisé. Veuillez vérifier à nouveau.",
  "token.expired": "Le token, ou clé d'authentification, est expiré. Veuillez vérifier avoir utilisé un lien pour modifier votre mot de passe, envoyé avant les dernières 48h.",
  "token.required": "Le token, ou clé d'authentification, est requis",
  "uplift.answer.error": "Une erreur est survenue. Votre réponse n'a pas été envoyée.",
  "uplift.message": "Message de soutien",
  "uplift.message.error": "Une erreur est survenue. Votre message de soutien n'a pas été envoyé.",
  "uplift.textarea.placeholder.long": "Laissez un message de soutien à {userName} ...",
  "uplift.textarea.placeholder.short": "Tapez votre message de soutien ...",
  "user.avatar.logo": "Mon logo",
  "user.communities": "Cet utilisateur propose",
  "user.communities.other": "Voir toutes les propositions",
  "user.delivery-issue-email.alert-message": "Il semble y avoir un problème avec votre adresse email",
  "user.delivery-issue-email.hard-bounce-invalid": "<p>Il semble y avoir un problème avec votre adresse email. Nous ne parvenons pas à vous envoyer les mails que vous souhaitez recevoir de la part d’Hozana 😅</p><p>Merci de vérifier votre adresse email.</p>",
  "user.delivery-issue-email.spam-report": "<p>Il semble que votre adresse email considère nos courriers comme \"Courriers indésirables\" ou \"SPAM\" 😞</p><p>Nous vous invitons à :<br/> • aller dans vos courriers indésirables et déplacer les derniers mails reçus d'Hozana dans votre boîte de réception,<br/> • puis ajouter \"contact@hozana.org\" à vos contacts (ou adresses enregistrées).</p><p>Si le problème persiste dans 3 jours, merci de cliquer sur le bouton \"Je signale un problème\" ci-dessous.</p>",
  "user.delivery-issue-email.verify-email": "Je vérifie mon adresse email",
  "user.happy-birthday.psalm": "C'est toi qui as créé mes reins, qui m'as tissé dans le sein de ma mère. Je reconnais devant toi le prodige, l'être étonnant que je suis […]",
  "user.happy-birthday.reference": "Psaume 139, 13-14",
  "user.happy-birthday.title": "Joyeux anniversaire\n{username} !",
  "user.happy-birthday.users-pray-for-you": "Aujourd'hui, des utilisateurs prient pour vous !",
  "user.happy-birthday.wish": "Joyeux anniversaire !",
  "user.home-location": "Dans quelle ville habitez-vous ?",
  "user.logout.word": "Se déconnecter",
  "user.mail.unsubscribe": "Vous ne recevrez plus de mails de notre part pour des demandes d’appels à dons pendant 1 an.",
  "user.not-found": "Cet utilisateur n'existe pas",
  "user.popins.avatars.choose-my-image": "Choisir mon image de profil",
  "user.profile.done-communities": "Mes inscriptions terminées",
  "user.profile.favorite-publications": "Publications favorites",
  "user.profile.my-profile": "Mon profil",
  "user.profile.questions.title.wizard": "Et enfin, pour personnaliser votre prière",
  "user.profile.questions.you-are": "Vous êtes",
  "user.profile.questions.your-birthdate": "Pour prier pour vous le jour de votre anniversaire, vous êtes né(e) le",
  "user.profile.questions.your-location": "Votre ville",
  "user.settings.click-to-fill": "Cliquez pour renseigner",
  "user.settings.tab.account.password-required": "Veuillez entrer votre mot de passe pour confirmation.",
  "user.title.brother": "Frère",
  "user.title.deacon": "Diacre",
  "user.title.family": "Famille",
  "user.title.father": "Père",
  "user.title.miss": "Mlle",
  "user.title.mr": "M.",
  "user.title.mrs": "Mme",
  "user.title.org": "Organisation",
  "user.title.sister": "Soeur",
  "user.wizard.audio": "Audio",
  "user.wizard.complete": "Nous recherchons\nce qui pourrait vous plaire...",
  "user.wizard.minutes": "min",
  "user.wizard.my-wizard": "Mes préférences de prière",
  "user.wizard.novena": "Neuvaine",
  "user.wizard.reading": "Lecture",
  "user.wizard.video": "Vidéo",
  "user.wizard.welcome.user": "Bienvenue {name} !",
  "user.wizard.what-themes": "Quels thèmes vous intéressent ?",
  "user.wizard.what-topics": "Un sujet vous tient à cœur en ce moment ?",
  "watchman.daily-counted.intentions": "{count, plural, one {Votre intention du jour} other {Vos {count} intentions du jour}}",
  "watchman.daily.close": "Voulez-vous arrêter de prier ?",
  "watchman.daily.continue": "Continuer à prier",
  "watchman.daily.intentions": "Vos intentions du jour",
  "watchman.daily.pray-for-more": "Prier pour plus d'intentions",
  "watchman.daily.remaining": "Il vous reste {count} intention{count, plural, one {} other {s}} pour aujourd'hui",
  "watchman.intentions.choice": "Choix des intentions",
  "watchman.intentions.explanation": "Les intentions sont choisies au hasard parmi celles qui ont reçu <strong>moins de 20 prières</strong>",
  "watchman.intentions.explanation.end": "Vous pouvez modifier chacune des intentions selon vos préférences, en cliquant sur l’icône 🔄 à côté de chaque intention.",
  "watchman.pray-for-today": "Prier pour aujourd'hui",
  "watchman.prayers.thank-you": "Merci pour vos prières",
  "watchman.prayers.thanks-for": "Merci pour {name}",
  "watchman.push.description": "<strong>Activez les notifications</strong> pour mieux suivre votre engagement comme Veilleur de prière.",
  "watchman.push.details": "Vous pourrez changer vos paramètres à tout moment.",
  "watchman.push.title": "Restez fidèle,<br/>recevez un rappel !",
  "watchman.rely.remains": "{count, plural, one {Une personne compte encore sur votre prière} other {{count} personnes comptent encore sur vos prières}}",
  "watchman.three.intentions": "Priez pour 3 intentions chaque jour",
  "widget.not-found": "Le widget \"intention\" n'a pas été trouvé",
  "wizard.communityFormats.unknown": "Oups ! petit problème, la sélection n'a pas fonctionné",
  "wizard.communityTypes.unknown": "Oups ! petit problème, la sélection n'a pas fonctionné",
  "wizard.prayerDuration.unknown": "Oups ! petit problème, la sélection n'a pas fonctionné",
  "wizard.tags.unknown": "Oups ! petit problème, la sélection n'a pas fonctionné",
  "word.all.feminine": "Toutes",
  "word.cancel": "Annuler",
  "word.characters": "{count, plural, =0 {Plus de caractères restants} one {1 caractère restant} other {{count} caractères restants}}",
  "word.choose": "Choisir",
  "word.close": "Fermer",
  "word.confirm": "Confirmer",
  "word.congratulations": "Bravo !",
  "word.continue": "Continuer",
  "word.create.content": "Créer du contenu",
  "word.days": "{count, plural, one {# jour} other {# jours}}",
  "word.edit": "Modifier",
  "word.email": "Email",
  "word.email-address": "Adresse email",
  "word.email-address-connection": "Adresse email de connexion",
  "word.email-address-notification": "Adresse email de notification",
  "word.finish": "Terminer",
  "word.in": "dans",
  "word.intentions": "Intentions",
  "word.leave-message": "Déposer",
  "word.next": "Suivant",
  "word.no": "Non",
  "word.notifications": "Notifications",
  "word.notifications.mails": "Notifications et mails",
  "word.prayers": "prières",
  "word.prayers-count": "{count, plural, one {{count} prière} other {{count} prières}}",
  "word.previous": "Précédent",
  "word.remove": "Supprimer",
  "word.save": "Enregistrer",
  "word.send": "Envoyer",
  "word.skip": "Passer",
  "word.start": "Commencer",
  "word.start-again": "Recommencer",
  "word.stop": "Arrêter",
  "word.thank-you": "Merci",
  "word.today": "Aujourd'hui",
  "word.validate": "Valider",
  "word.watchman": "Veilleur de prière",
  "word.whats-next": "Que souhaitez-vous faire maintenant ?",
  "word.yes": "Oui",
  "word.yesterday": "Hier",
  "word.you": "Vous",
  "word.your-firstname": "Votre prénom",
  "word.your-title": "Votre civilité",
  "wording.i-share": "Je partage",
  "words.a-man": "Un homme",
  "words.a-woman": "Une femme",
  "words.answer": "Répondre",
  "words.by-user": "Par {userName}",
  "words.click-here": "Cliquez ici",
  "words.contact-us": "Nous contacter",
  "words.daily": "Au quotidien",
  "words.done": "C'est fait",
  "words.has-prayed": "{contactName} a prié",
  "words.hello.user": "Bonjour {userName},",
  "words.home-page": "Page d’accueil",
  "words.i-check": "Je vérifie",
  "words.i-continue": "Je continue",
  "words.i-subscribe": "Je m'inscris",
  "words.in-nb-days": "Dans {nbDays} {nbDays, plural, one {jour} other {jours}}",
  "words.in-nb-days-begin": "Commence dans {nbDays} {nbDays, plural, one {jour} other {jours}}",
  "words.know-more": "En savoir plus",
  "words.maybe-later": "Peut-être plus tard",
  "words.nb-days": "{nbDays} {nbDays, plural, one {jour} other {jours}}",
  "words.no-thanks": "Non, merci",
  "words.no-thanks2": "Non merci",
  "words.not-now": "Pas maintenant",
  "words.ongoing": "En ce moment",
  "words.password.placeholder": "Votre mot de passe",
  "words.profile": "Profil",
  "words.see": "Voir",
  "words.see-all.plur-fem": "Voir toutes",
  "words.see-all.sing": "Voir tout",
  "words.sign-up": "S'inscrire",
  "words.terms-of-use": "Conditions d'utilisation",
  "words.thank": "Remercier",
  "words.thank-you-very-much": "Merci beaucoup ! 😊",
  "words.thanked": "Remercié",
  "words.you-prayed": "Vous avez prié",
  "words.your-email-address": "Votre adresse email",
  "words.your-intention": "Votre intention",
  "words.your-message": "Votre message"
}
